import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL;

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const token = sp.get('token') || '';
  const [valid, setValid] = useState(false);
  const [pw, setPw] = useState('');
  const [msg, setMsg] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    async function check() {
      if (!token) return;
      const r = await fetch(`${API}/auth/reset-token/${token}`);
      setValid(r.ok);
    }
    check();
  }, [token]);

  async function handleSubmit(e) {
    e.preventDefault();
    setMsg('');
    try {
      const r = await fetch(`${API}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type':'application/json' },
        body: JSON.stringify({ token, password: pw })
      });
      const data = await r.json();
      if (!r.ok) throw new Error(data.error || 'Feil');
      setMsg('Passord oppdatert! Du kan nå logge inn.');
      setTimeout(()=> navigate('/login'), 1200);
    } catch (e) {
      setMsg('Feil: ' + e.message);
    }
  }

  if (!token) return <div className="max-w-md mx-auto mt-20">Mangler token.</div>;
  if (!valid)  return <div className="max-w-md mx-auto mt-20">Ugyldig/utløpt lenke.</div>;

  return (
    <div className="max-w-md mx-auto mt-20 bg-white p-8 rounded-lg shadow">
      <h1 className="text-2xl font-bold text-[#000099] mb-4">Sett nytt passord</h1>
      <form onSubmit={handleSubmit} className="space-y-3">
        <input
          type="password"
          placeholder="Nytt passord"
          value={pw}
          onChange={e=>setPw(e.target.value)}
          required
          className="w-full border rounded px-3 py-2"
        />
        <button className="w-full bg-[#000099] text-white font-semibold py-2 px-4 rounded">
          Lagre
        </button>
      </form>
      {msg && <p className="mt-3 text-sm">{msg}</p>}
    </div>
  );
}
